const img = require('./Cipher.png'); export default img;